import comp from "./EmptyState";
export default comp;
